import { useState } from "react";
import { TIER_META, type Tier } from "../lib/pricing";
import type { TicketGroup } from "../types/api";
import styles from "./TicketListing.module.css";

type Props = {
  group: TicketGroup;
  tier: Tier;
  isHighlighted: boolean;
  onAdd: (group: TicketGroup, quantity: number) => void;
  onHover: (sectionName: string | null) => void;
};

export default function TicketListing({
  group,
  tier,
  isHighlighted,
  onAdd,
  onHover,
}: Props) {
  const [quantity, setQuantity] = useState<number>(group.splits[0] ?? 1);
  const meta = TIER_META[tier];

  return (
    <div
      className={`${styles.row} ${isHighlighted ? styles.highlighted : ""}`}
      onMouseEnter={() => onHover(group.section)}
      onMouseLeave={() => onHover(null)}
    >
      <div className={styles.tierStripe} style={{ background: meta.gradient }} />
      <div className={styles.main}>
        <div className={styles.head}>
          <span
            className={styles.tierBadge}
            style={{
              background: meta.soft,
              color: meta.solid,
              borderColor: `${meta.solid}55`,
            }}
          >
            {meta.label}
          </span>
          <span className={styles.qtyAvail}>
            {group.quantityAvailable} avail
          </span>
        </div>
        <div className={styles.section}>
          {group.section}
          <span className={styles.row_label}>· Row {group.row}</span>
        </div>
        <div className={styles.splits}>
          Splits: {group.splits.join(", ")}
        </div>
      </div>

      <div className={styles.cta}>
        <div className={styles.priceBlock}>
          <span className={styles.priceValue}>
            ${Math.round(group.pricePerTicket)}
          </span>
          <span className={styles.priceUnit}>/ ticket</span>
        </div>
        <div className={styles.controls}>
          <select
            className={styles.qty}
            value={quantity}
            onChange={(e) => setQuantity(Number(e.target.value))}
            aria-label="Quantity"
          >
            {group.splits.map((q) => (
              <option key={q} value={q}>
                {q} {q === 1 ? "ticket" : "tickets"}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onAdd(group, quantity)}
          >
            Get tickets
          </button>
        </div>
      </div>
    </div>
  );
}
